import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'semantic-ui-react'
import Text from "../Text";
import { COLORS } from '../../design/tokens';
import { styleUtils } from "../../utils";
import styles from "./styles";

const { style } = styleUtils;
const ListItem = style(List.Item, styles.listItem);

const Nav = ({items, ...otherProps}) => {
  const itemProps = {
    size: 'large',
    color: COLORS.WHITE,
    weight: 'normal'
  }
  return (
    <nav {...otherProps}>
      <List link horizontal>
        {
          items.map(item => (
            <ListItem key={item.to}>
              <a href={item.to}><Text {...itemProps}>{item.label}</Text></a>
            </ListItem>
          ))
        }
      </List>
    </nav>
  )
};

Nav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    to: PropTypes.string
  })).isRequired
}

Nav.defaultProps = {
  items: []
}

export default Nav;
